export var SUPPORTED_VIDEO_CODECS = ['h264'];